import type { Loading } from "@/lib/loading"

const unloadedProcess = { loading: true }

export const unloadedProcesses: Loading.Processes = {
  appointments: unloadedProcess,
  authentication: unloadedProcess,
  background: unloadedProcess,
  bookingSearch: unloadedProcess,
  bookingSource: unloadedProcess,
  caching: unloadedProcess,
  geolocation: unloadedProcess,
  notices: unloadedProcess,
  routing: unloadedProcess,
  services: unloadedProcess,
}
